import React, { useState } from 'react';
import './StudyFilter.css';

const StudyFilter = ({ templates = [], filters, onChange }) => {
  const [search, setSearch] = useState(filters.search || '');

  const handleChange = (key, value) => {
    onChange({ ...filters, [key]: value });
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    handleChange('search', search);
  };

  const handleReset = () => {
    setSearch('');
    onChange({ page: 1, limit: 20 });
  };

  const hasActiveFilter = filters.template_id || filters.tags || filters.search;

  return (
    <div className="study-filter">
      {/* 검색 */}
      <form className="study-filter-search" onSubmit={handleSearchSubmit}>
        <input
          type="text"
          className="study-filter-input"
          placeholder="제목 검색..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
        <button type="submit" className="study-filter-search-btn">검색</button>
      </form>

      <div className="study-filter-row">
        {/* 템플릿 선택 */}
        <div className="study-filter-group">
          <label className="study-filter-label">템플릿</label>
          <select
            className="study-filter-select"
            value={filters.template_id || ''}
            onChange={(e) => handleChange('template_id', e.target.value)}
          >
            <option value="">전체</option>
            {templates.map((t) => (
              <option key={t.id} value={t.id}>{t.name}</option>
            ))}
          </select>
        </div>

        {/* 태그 */}
        <div className="study-filter-group">
          <label className="study-filter-label">태그</label>
          <input
            type="text"
            className="study-filter-input"
            placeholder="태그 (콤마 구분)"
            value={filters.tags || ''}
            onChange={(e) => handleChange('tags', e.target.value)}
          />
        </div>

        {/* 초기화 */}
        {hasActiveFilter && (
          <button
            type="button"
            className="study-filter-reset-btn"
            onClick={handleReset}
          >
            필터 초기화
          </button>
        )}
      </div>
    </div>
  );
};

export default StudyFilter;
